<template>
  <div>
    <div
      v-for="item in items"
      :key="`items-${item.pk}`"
      class="assingItem elevation-1"
    >
      <v-col cols="12" sm="6" md="4" class="align-content-center">
        <div class="d-flex flex-row align-items-center">
          <!-- Foto del item si es un conductor -->
          <v-list-item-avatar size="60" color="grey darken-3">
            <i-image :value="item.photo" :preview="true" :readonly="true" />
          </v-list-item-avatar>

          <!-- Nombre del conductor o el producto de la suborden -->
          <span>{{ `${item.first_name} ${item.last_name}` }}</span>
        </div>
      </v-col>

      <!-- Asignación de usuario o mensaje de alerta si no se puede asignar -->
      <v-col cols="12" sm="6" md="8" class="align-content-center">
        <assign-user
          v-if="isProducerAssignable(item)"
          :selectedItem="item.pk"
          :mode="mode"
          :template="item.template"
        />
        <v-alert v-else type="info" outlined color="primary">
          <span class="primary--text font-weight-black">
            {{ $t('assignProduction_no') }}
          </span>
        </v-alert>
      </v-col>
    </div>
  </div>
</template>

<script>
import AssignUser from '@/components/delivery/infoAssignDriver.vue'

export default {
  components: {
    AssignUser
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    mode: {
      type: String,
      default: 'designer'
    }
  },
  methods: {
    /**
     * Método para determinar si un productor puede ser asignado a una suborden
     * basada en el modo 'production' y el estado de la orden.
     *
     * @param {Object} item - El objeto de la suborden que contiene información
     *                        para la asignación.
     * @returns {boolean} - Devuelve verdadero si el productor puede ser
     *                      asignado, de lo contrario, devuelve falso.
     *
     * Rosana Mendez <rosanamendez5 at gmail.com>
     */
    isProducerAssignable(item) {
      const validModes = ['delivery', 'driver', 'designer']
      const invalidOrderStatuses = [
        'design_under_review - in_wait',
        'design - in_wait',
        'design - in_design'
      ]
      const isValidMode = validModes.includes(this.mode)
      const isProduction = this.mode === 'production'
      const isOrderStatusInvalid = invalidOrderStatuses.includes(
        item.orderStatus
      )
      const isOrderStatusValid =
        item.orderStatus === '' ||
        item.orderStatus === 'design - finished' ||
        item.orderStatus === 'production - in_wait' ||
        item.orderStatus === 'production - finished'
      return (
        isValidMode ||
        (isProduction && !isOrderStatusInvalid && isOrderStatusValid)
      )
    }
  }
}
</script>
<style lang="sass">
.assingItem
  background-color: rgb(220 220 220 / .3)
  border-radius: 15px
  display: flex
  flex-wrap: wrap
  margin-bottom: 16px
  padding-bottom: 12px
.theme--dark
  .assingItem
    background-color: rgb(0 0 0 / .25)

.assingItem--title
  border-top-left-radius: 15px
  border-top-right-radius: 15px
</style>
